import React from 'react'
import { connect } from 'react-redux'
import withSizes from 'react-sizes'
import { bool, func } from 'prop-types'
import { Div, P } from '../styles/SmallMap'
import Map from '../../../Map'
import { handleToggleSearchContent } from '../../../../store/Actions/UiActions'

const SmallMap = ({
  isSmallScreen,
  theme,
  handleToggleSearchContent,
  listShow,
  streetViewShow,
  cycloramaShow,
}) =>
  (isSmallScreen || listShow || streetViewShow || cycloramaShow) && (
    <Div>
      <Map height="100%" width="100%" fitBounds={true} />
      {isSmallScreen && (
        <P theme={theme} onClick={() => handleToggleSearchContent(false)}>
          Full Map
        </P>
      )}
    </Div>
  )

SmallMap.propTypes = {
  isSmallScreen: bool.isRequired,
  handleToggleSearchContent: func.isRequired,
  streetViewShow: bool.isRequired,
  cycloramaShow: bool.isRequired,
}

const mapStateToProps = ({ spi, ui }) => ({
  theme: spi.theme,
  listShow: ui.listShow,
  streetViewShow: ui.streetViewShow,
  cycloramaShow: ui.cycloramaShow,
})

const mapSizesToProps = ({ width }) => ({ isSmallScreen: width <= 768 })

const mapDispatchToProps = dispatch => ({
  handleToggleSearchContent: value =>
    dispatch(handleToggleSearchContent(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withSizes(mapSizesToProps)(SmallMap)
)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SmallMap/index.jsx